module.exports = __webpack_public_path__ + "55d6ded.ttf";